import { isNorthAmerican, isPhase4Country, isEmeaCountry, SUPPORTED_COUNTRIES } from 'constants/countryCodes';
import { cropIds } from 'constants/crops';

// Temporary logic for determining whether or not to display bag text based on requirements from i18n phase4
// If you need to make additions to this file's logic, please work together with the Product team to determine
// if there is a more generic solution. We'd rather not have to use this file any more than is necessary.
// Long term, when bag size is provided and accepted by product for all supported countries, we can remove this file.
export const bagText = (countryCode, bagValue, cropId) => {
  switch (Number(cropId)) {
    case cropIds.CORN:
      return isNorthAmerican(countryCode)
      || countryCode === SUPPORTED_COUNTRIES.BRAZIL
      || isPhase4Country(countryCode)
      || isEmeaCountry(countryCode)
        ? bagValue
        : '--';
    case cropIds.SOYBEAN:
      return isNorthAmerican(countryCode) ? bagValue : '--';
    default:
      return '--';
  }
};
